export default "__VITE_ASSET__DE3R07SI__"